import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import HomePage from './pages/Homepage';
import Questionario from './pages/Questionario';
import ExportDati from './pages/admin/ExportDati';
import Prestazioni from './pages/admin/Prestazioni';
import ReCAPTCHA from 'react-google-recaptcha';
import Login from './pages/Login';
import PrivateRoutes from './util/PrivateRoutes';
import Dashboard from './pages/admin/Dashboard';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import it from 'dayjs/locale/it';
import { itIT } from '@mui/x-date-pickers/locales';
import { useTranslation } from 'react-i18next';
import HomepageDeg from './pages/HomepageDeg';
import QuestionarioDeg from './pages/QuestionarioDeg';
const theme = createTheme({
  palette: {
    mode: 'light',
  },
});


const App = () => {
  function onChangeCaptcha(value) {
  }
  const { i18n } = useTranslation();

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={i18n?.language.includes("en") ? null : it } localeText={i18n?.language.includes("en") ? null : itIT.components.MuiLocalizationProvider.defaultProps.localeText}>
    <ThemeProvider theme={theme}>
              <CssBaseline />
          <Router>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/degenti" element={<HomepageDeg />} />
              <Route path="/questionario" element={<Questionario />} />
              <Route path="/questionariodeg" element={<QuestionarioDeg/>} />
              <Route path="/login" element={<Login />} />
              
              <Route element={<PrivateRoutes />}>
                    <Route path="/admin/dashboard" element={<Dashboard />} />
                    <Route path="/admin/exportDati" element={<ExportDati />} />
                    <Route path="/admin/prestazioni" element={<Prestazioni />} />
              </Route>

            </Routes>
          </Router>
          <ReCAPTCHA
                    sitekey="6LdPtFglAAAAAK5eqmm_d0dyeqZeQmnNh8iMwk9m"
                    onChange={onChangeCaptcha}
                    badge="bottomright"
                    size='invisible'
                  />
    </ThemeProvider>
    </LocalizationProvider>
     
    
  )
};

    
    export default App;